module.exports = __webpack_public_path__ + "SMS.svg?f93b3505aa715006a997a537f8549b25";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/SMS.svg
// module id = 106
// module chunks = 0